var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53028 13.9584C9.83968 14.137 10.2209 14.137 10.5303 13.9584L14.3567 11.7492C14.6661 11.5705 14.8567 11.2404 14.8567 10.8831V6.46476C14.8567 6.1075 14.6661 5.77737 14.3567 5.59874L10.5303 3.38955C10.2209 3.21092 9.83968 3.21092 9.53028 3.38955L5.70388 5.59874C5.39448 5.77737 5.20389 6.1075 5.20389 6.46476V10.8831C5.20389 11.2404 5.39448 11.5705 5.70388 11.7492L9.53028 13.9584ZM7.20389 10.3058V7.04211L10.0303 5.41028L12.8567 7.04211V10.3058L10.0303 11.9376L7.20389 10.3058Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3817 20.6138C13.6911 20.7924 14.0723 20.7924 14.3817 20.6138L18.2081 18.4046C18.5175 18.226 18.7081 17.8959 18.7081 17.5386V13.1202C18.7081 12.7629 18.5175 12.4328 18.2081 12.2542L14.3817 10.045C14.0723 9.86636 13.6911 9.86636 13.3817 10.045L9.55527 12.2542C9.24587 12.4328 9.05527 12.7629 9.05527 13.1202V17.5386C9.05527 17.8959 9.24587 18.226 9.55527 18.4046L13.3817 20.6138ZM11.0553 16.9612V13.6976L13.8817 12.0657L16.7081 13.6976V16.9612L13.8817 18.5931L11.0553 16.9612Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0302 5.24358C10.5825 5.24358 11.0302 4.79587 11.0302 4.24358V2C11.0302 1.44772 10.5825 1 10.0302 1C9.47792 1 9.03021 1.44772 9.03021 2V4.24358C9.03021 4.79587 9.47792 5.24358 10.0302 5.24358Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0075 19.4436C21.2836 18.9653 21.1198 18.3537 20.6415 18.0776L18.2079 16.6726C17.7296 16.3964 17.118 16.5603 16.8419 17.0386C16.5658 17.5169 16.7296 18.1285 17.2079 18.4046L19.6415 19.8096C20.1198 20.0858 20.7314 19.9219 21.0075 19.4436Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8816 23C14.4339 23 14.8816 22.5523 14.8816 22V19.7478C14.8816 19.1955 14.4339 18.7478 13.8816 18.7478C13.3293 18.7478 12.8816 19.1955 12.8816 19.7478V22C12.8816 22.5523 13.3293 23 13.8816 23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06994 6.96477C7.34608 6.48648 7.18221 5.87488 6.70392 5.59874L4.35857 4.24464C3.88028 3.9685 3.26869 4.13237 2.99254 4.61066C2.7164 5.08895 2.88027 5.70055 3.35856 5.97669L5.70391 7.33079C6.1822 7.60693 6.7938 7.44306 7.06994 6.96477Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9848 19.8886C6.26094 20.3669 6.87253 20.5308 7.35083 20.2546L10.5552 18.4046C11.0335 18.1284 11.1973 17.5169 10.9212 17.0386C10.645 16.5603 10.0335 16.3964 9.55516 16.6725L6.35082 18.5226C5.87253 18.7987 5.70866 19.4103 5.9848 19.8886Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreservations);
export default __webpack_public_path__ + "static/media/preservations.68e33455db09bc439bcc1c65e65fe07f.svg";
export { ForwardRef as ReactComponent };